var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.43669 18.5101C4.75002 18.5101 0.92627 14.6943 0.92627 9.99967C0.92627 5.30509 4.75002 1.48926 9.43669 1.48926C14.1234 1.48926 17.9471 5.30509 17.9471 9.99967C17.9471 14.6943 14.1313 18.5101 9.43669 18.5101ZM9.43669 2.67676C5.39919 2.67676 2.11377 5.96217 2.11377 9.99967C2.11377 14.0372 5.39919 17.3226 9.43669 17.3226C13.4742 17.3226 16.7596 14.0372 16.7596 9.99967C16.7596 5.96217 13.4742 2.67676 9.43669 2.67676Z",
    fill: "#FF3D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6034 10.5938H6.27002C5.94544 10.5938 5.67627 10.3246 5.67627 10C5.67627 9.67542 5.94544 9.40625 6.27002 9.40625H12.6034C12.9279 9.40625 13.1971 9.67542 13.1971 10C13.1971 10.3246 12.9359 10.5938 12.6034 10.5938Z",
    fill: "#FF3D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveField);
export default __webpack_public_path__ + "static/media/removeField.a156ec4cd09f5160b6f709fe02823674.svg";
export { ForwardRef as ReactComponent };